/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import { GoogleApiWrapper, Map, InfoWindow, Marker } from 'google-maps-react';

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

export class GMap extends React.Component {
  state = {
    bounds: null,
    showingInfoWindow: true,
    activeMarker: {},
    selectedPlace: {},
  };

  componentDidUpdate(prevProps) {
    if (this.props.listMarkers !== prevProps.listMarkers) {
      const { listMarkers, google } = this.props;
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < listMarkers.length; i++) {
        bounds.extend(listMarkers[i]);
      }
      this.setState({
        bounds,
      });
    }
  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  }

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        //activeMarker: null
      });
    }
  }

  render() {
    const { listMarkers, google, gMapStyle, markerInfo, mapOptions } = this.props;
    const { activeMarker, bounds, showingInfoWindow } = this.state;

    return (
      <Map
        onClick={this.onMapClicked}
        containerStyle={containerStyle}
        styles={gMapStyle}
        google={google}
        bounds={listMarkers.length > 1 ? bounds : null}
        initialCenter={{
          lat: listMarkers.length > 1 ? listMarkers[0].lat : 0,
          lng: listMarkers.length > 1 ? listMarkers[0].lng : 0,
        }}
        zoom={2}
        {...mapOptions}
      >
        {listMarkers.map((item) => (
          <Marker
            key={item.name}
            name={item.name}
            data={item}
            position={{ lat: item.lat, lng: item.lng }}
            onClick={this.onMarkerClick}
            icon={{
              url: 'https://res.mundigea.com.ar/img/recursos/icon-map_small.png',
              anchor: new google.maps.Point(16, 16),
              scaledSize: new google.maps.Size(40, 40),
            }}
          />
        ))}
        <InfoWindow
          marker={activeMarker}
          visible={showingInfoWindow}
        >
          {showingInfoWindow && activeMarker.data ? (
            <div>
              {markerInfo(activeMarker.data)}
            </div>
          )
            : <div>&nbsp;</div>}
        </InfoWindow>
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (process.env.RAZZLE_GOOGLE_MAPS_API_KEY),
})(GMap);
